
import React, { useRef } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { apiMainUser } from '../../../utils/constant';
import Button from '../../../Components/common/Button';

const HostEmailOtp = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const otpInputs = useRef([]);

  const onSubmit = async (data) => {
    const emailOtpValue = Object.keys(data)
      .sort()
      .map((key) => data[key])
      .join('');

    const newData = {
      email_otp: parseInt(emailOtpValue),
      email: props.emaildata,
    };

    try {
      const response = await axios.post(apiMainUser + 'change_mobile_email', newData, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
      });

      if (response.data.status === 'success') {
        props.fetchData();
        props.closeModal();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleInputChange = (index, event) => {
    const value = event.target.value;

    if (value.length === 1 && index < otpInputs.current.length - 1) {
      otpInputs.current[index + 1].focus();
    }

    setValue(`otp${index}`, value); // Set the value in react-hook-form
  };

  return (
    <form className='host-email-otp-div' onSubmit={handleSubmit(onSubmit)}>
      <h2>Verify your Email</h2>
      <p>Enter the verification code sent to your email</p>
      <div className='otp-input'>
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <input
            key={index}
            {...register(`otp${index}`, { required: true })}
            ref={(el) => (otpInputs.current[index] = el)}
            type="text"
            maxLength={1}
            onChange={(e) => handleInputChange(index, e)}
          />
        ))}
      </div>
      {errors && Object.keys(errors).length > 0 && <span>This field is required.</span>}
      <div className='paddingCustomAllSide'>
      <Button btnText='save' btnclasses='save-edit-btn '/> 
      </div>
    </form>
  );
};

export default HostEmailOtp;
